import { GenericError } from '@com-delta-idp/mnx-utils';

export interface MembershipCardResponse {
  url?: string;
  errorResponse?: BarCodeErrorResponse;
}

export interface BarCodeErrorResponse {
  code: string;
  developerMessage: string;
  message: string;
  moreInfo?: GenericError[];
}
